import { __assign } from "tslib";
import '../index.global.scss';
import theme from './theme.scss';
export default __assign({}, theme);
//# sourceMappingURL=index.js.map